import HomePageComponents from "../components/HomePageComponents";

function HomePage() {
  return (
    <>
      <HomePageComponents />
    </>
  );
}

export default HomePage;
